import ApiService from '../apiservice'

export default class CmdService extends ApiService {
    constructor() {
        super('');
    }

    sendCmdDeviceStatus(data) {
        return this.post('/cmd/device/status', data, 1);
    }

    sendMatch(data) {
        return this.post('/cmd/match', data, 1);
    }

    sendQualification(data, type) {
        return this.post('/cmd/' + type, data, 1);
    }

    sendBlock(data, type) {
        return this.post('/cmd/' + type, data, 1);
    }

    sendRoute(data, type) {
        return this.post('/cmd/route/' + type, data, 1);
    }

    sendStatusRequest(data) {
        return this.post('/cmd/status', data, 1);
    }

    getStatusPlate(plate) {
        return this.get('/cmd/status', { "plate": plate });
    }

    loadroute(data) {
        return this.post('/cmd/loadroute', data, 1);
    }

    getHorimeterHistory(data) {
        return this.get('/cmd/historyHorimeter', data);
    }

    


}